import { refreshAuthToken } from "./refreshAuthToken";

let refreshTokenPromise: Promise<string> | null = null;

export const getOrRefreshAuthToken = async (): Promise<string> => {
  if (!refreshTokenPromise) {
    refreshTokenPromise = refreshAuthToken().finally(() => {
      refreshTokenPromise = null;
    });
  }

  return refreshTokenPromise;
};